module.exports = __webpack_public_path__ + "static/media/homepage.32aca66a.png";